import { estadoCivilPessoaFisicaOptions } from "./dynamicTextRegistry";

const showConjugeWhenCasado = {
  field: "ESTADO_CIVIL_PESSOA_FISICA",
  value: "casado",
};

const pessoaFisicaFields = [
  { id: "NOME_PESSOA_FISICA", label: "Nome", type: "text", required: true },
  {
    id: "CPF_PESSOA_FISICA",
    label: "CPF",
    type: "text",
    required: true,
    mask: "cpf",
  },
  { id: "RG_PESSOA_FISICA", label: "RG", type: "text" },
  { id: "NACIONALIDADE_PESSOA_FISICA", label: "Nacionalidade", type: "text" },
  { id: "PROFISSAO_PESSOA_FISICA", label: "Profissão", type: "text" },
  {
    id: "ESTADO_CIVIL_PESSOA_FISICA",
    label: "Estado civil",
    type: "select",
    required: true,
    options: estadoCivilPessoaFisicaOptions,
    placeholder: "Selecione",
  },
  {
    id: "NOME_CONJUGE",
    label: "Nome do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "CPF_CONJUGE",
    label: "CPF do cônjuge",
    type: "text",
    mask: "cpf",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "RG_CONJUGE",
    label: "RG do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "NACIONALIDADE_CONJUGE",
    label: "Nacionalidade do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "PROFISSAO_CONJUGE",
    label: "Profissão do cônjuge",
    type: "text",
    showWhen: showConjugeWhenCasado,
  },
  {
    id: "EMAIL_CONJUGE",
    label: "E-mail do cônjuge",
    type: "email",
    required: true,
    showWhen: showConjugeWhenCasado,
  },
  { id: "RUA_ENDERECO_PESSOA_FISICA", label: "Rua", type: "text" },
  { id: "N_ENDERECO_PESSOA_FISICA", label: "Número", type: "text" },
  { id: "BAIRRO_ENDERECO_PESSOA_FISICA", label: "Bairro", type: "text" },
  { id: "MUN_ENDERECO_PESSOA_FISICA", label: "Município", type: "text" },
  { id: "CEP_PESSOA_FISICA", label: "CEP", type: "text" },
  { id: "EMAIL_PESSOA_FISICA", label: "Email", type: "email", required: true },
  {
    id: "TEL_PESSOA_FISICA",
    label: "Telefone",
    type: "text",
    mask: "phone",
  },
];

const compromissoCompraVendaFormSchema = [
  // =====================================================
  // VENDEDORES (REPEATABLE)
  // =====================================================
  {
    sectionId: "vendedores",
    sectionLabel: "Vendedores",
    repeatable: true,
    groupKey: "vendedores",
    minItems: 1,
    fields: [...pessoaFisicaFields],
  },

  // =====================================================
  // COMPRADORES (REPEATABLE)
  // =====================================================
  {
    sectionId: "compradores",
    sectionLabel: "Compradores",
    repeatable: true,
    groupKey: "compradores",
    minItems: 1,
    fields: [...pessoaFisicaFields],
  },

  // =====================================================
  // TESTEMUNHAS (REPEATABLE)
  // =====================================================
  {
    sectionId: "testemunhas",
    sectionLabel: "Testemunhas",
    repeatable: true,
    groupKey: "testemunhas",
    fields: [
      { id: "NOME_TESTEMUNHA", label: "Nome", type: "text", required: true },
      {
        id: "CPF_TESTEMUNHA",
        label: "CPF",
        type: "text",
        required: true,
        mask: "cpf",
      },
      { id: "EMAIL_TESTEMUNHA", label: "Email", type: "email", required: true },
    ],
  },

  // =====================================================
  // TIPO DE IMÓVEL (CONDITIONAL)
  // =====================================================
  {
    sectionId: "tipo-imovel",
    sectionLabel: "Tipo de Imóvel",
    type: "conditional",
    groupKey: "tipo_imovel",
    requireTypeSelection: true,
    options: {
      casa: [
        { id: "ENDERECO_IMOVEL", label: "Endereço", type: "text" },
        { id: "NUMERO_IMOVEL", label: "Número", type: "text" },
        { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "AREA_CONSTRUIDA", label: "Área Construída", type: "text" },
        { id: "AREA_TERRENO", label: "Área do Terreno", type: "text" },
        { id: "DESCRICAO_IMOVEL", label: "Descrição do Imóvel", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
      ],

      apartamento: [
        { id: "ANDAR_AP", label: "Andar", type: "text" },
        { id: "VAGA_GARAGEM", label: "Vagas de Garagem", type: "text" },
        { id: "NOME_COND", label: "Condomínio", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
      ],

      galpao: [
        { id: "ENDERECO_IMOVEL", label: "Endereço", type: "text" },
        { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "UF_IMOVEL", label: "UF", type: "text" },
        { id: "AREA_TOTAL", label: "Área Total (m²)", type: "text" },
        { id: "DESCRICAO_IMOVEL", label: "Descrição do Imóvel", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
      ],

      lote: [
        { id: "ENDERECO_IMOVEL", label: "Endereço", type: "text" },
        { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "UF_IMOVEL", label: "UF", type: "text" },
        { id: "AREA_TOTAL", label: "Área Total (m²)", type: "text" },
        { id: "DESCRICAO_IMOVEL", label: "Descrição do Imóvel", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
      ],

      rural: [
        { id: "LOCALIDADE_IMOVEL", label: "Localidade", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "UF_IMOVEL", label: "UF", type: "text" },
        { id: "AREA_TOTAL", label: "Área Total", type: "text" },
        { id: "UNIDADE_AREA", label: "Unidade de Área", type: "text" },
        { id: "DESCRICAO_IMOVEL", label: "Descrição do Imóvel", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
        { id: "CCIR_IMOVEL", label: "CCIR", type: "text" },
      ],

      salacomercial: [
        { id: "ENDERECO_IMOVEL", label: "Endereço", type: "text" },
        { id: "BAIRRO_IMOVEL", label: "Bairro", type: "text" },
        { id: "MUN_IMOVEL", label: "Município", type: "text" },
        { id: "UF_IMOVEL", label: "UF", type: "text" },
        { id: "AREA_TOTAL", label: "Área Total (m²)", type: "text" },
        { id: "DESCRICAO_IMOVEL", label: "Descrição do Imóvel", type: "text" },
        { id: "MAT_IMOVEL", label: "Matrícula", type: "text" },
        { id: "N_CARTORIO", label: "Cartório", type: "text" },
        { id: "MUN_CARTORIO", label: "Município do Cartório", type: "text" },
      ],
    },
  },

  // =====================================================
  // TIPO COMISSÃO
  // =====================================================
  {
    sectionId: "tipo-comissao",
    sectionLabel: "Tipo de Comissão",
    type: "conditional",
    groupKey: "tipo_comissao",
    requireTypeSelection: true,
    options: {
      corretor: [
        {
          id: "CORRETOR",
          label: "Nome do Corretor",
          type: "text",
          required: true,
        },
        {
          id: "CRECI",
          label: "CRECI do Corretor",
          type: "text",
          required: true,
        },
        {
          id: "COMISSAO",
          label: "Valor da Comissão",
          type: "text",
          required: true,
        },
      ],

      imobiliaria: [
        {
          id: "IMOBILIARIA",
          label: "Nome da Imobiliária",
          type: "text",
          required: true,
        },
        {
          id: "CRECI_IMOBILIARIA",
          label: "CRECI da Imobiliária",
          type: "text",
          required: true,
        },
        {
          id: "CORRETOR",
          label: "Nome do Corretor",
          type: "text",
          required: true,
        },
        {
          id: "CRECI_CORRETOR",
          label: "CRECI do Corretor",
          type: "text",
          required: true,
        },
        {
          id: "COMISSAO",
          label: "Valor da Comissão",
          type: "text",
          required: true,
        },
      ],
    },
  },

  // =====================================================
  // TIPO DE PAGAMENTO (CONDITIONAL)
  // =====================================================
  {
    sectionId: "tipo-pagamento",
    sectionLabel: "Tipo de Pagamento",
    type: "conditional",
    groupKey: "tipo_pagamento",
    requireTypeSelection: true,
    options: {
      avista: [
        {
          id: "VALOR_TOTAL",
          label: "Valor total (R$)",
          type: "text",
          mask: "brl_currency",
          required: true,
        },
        {
          id: "VALOR_TOTAL_EXTENSO",
          label: "Valor total por extenso",
          type: "text",
          required: true,
        },
        {
          id: "FORMA_PAGAMENTO",
          label: "Forma de pagamento",
          type: "text",
          required: true,
        },
        {
          id: "DATA_PAGAMENTO",
          label: "Data do pagamento",
          type: "date",
          required: true,
        },
        {
          id: "VALOR_ARRAS",
          label: "Arras (R$)",
          type: "text",
          mask: "brl_currency",
          required: true,
        },
        {
          id: "VALOR_ARRAS_EXTENSO",
          label: "Arras por extenso",
          type: "text",
          required: true,
        },
      ],

      aprazo: [
        {
          id: "VALOR_TOTAL",
          label: "Valor total (R$)",
          type: "text",
          mask: "brl_currency",
          required: true,
        },
        {
          id: "VALOR_TOTAL_EXTENSO",
          label: "Valor total por extenso",
          type: "text",
          required: true,
        },
        {
          id: "VALOR_ENTRADA",
          label: "Entrada (R$)",
          type: "text",
          mask: "brl_currency",
          required: true,
        },
        {
          id: "FORMA_PAGAMENTO_ENTRADA",
          label: "Forma de pagamento (entrada)",
          type: "text",
          required: true,
        },
        {
          id: "DATA_ENTRADA",
          label: "Data da entrada",
          type: "date",
          required: true,
        },
        {
          id: "FORMA_PAGAMENTO_SALDO",
          label: "Forma de pagamento do saldo",
          type: "text",
          required: true,
        },
        {
          id: "PERCENTUAL_MULTA",
          label: "Multa (%)",
          type: "text",
          mask: "decimal_br",
          required: true,
        },
        {
          id: "JUROS_MORA",
          label: "Juros de mora (% ao mês)",
          type: "text",
          mask: "decimal_br",
          required: true,
        },
      ],

      permuta: [
        {
          id: "VALOR_TOTAL",
          label: "Valor total (R$)",
          type: "text",
          mask: "brl_currency",
          required: true,
        },
        {
          id: "VALOR_TOTAL_EXTENSO",
          label: "Valor total por extenso",
          type: "text",
          required: true,
        },
        {
          id: "DESCRICAO_BEM_PERMUTA",
          label: "Descrição do bem em permuta",
          type: "text",
          required: true,
        },
        {
          id: "VALOR_PERMUTA",
          label: "Valor atribuído ao bem (R$)",
          type: "text",
          mask: "brl_currency",
          required: true,
        },
        {
          id: "VALOR_PERMUTA_EXTENSO",
          label: "Valor do bem por extenso",
          type: "text",
          required: true,
        },
        {
          id: "VALOR_SALDO",
          label: "Saldo (R$)",
          type: "text",
          mask: "brl_currency",
          required: true,
        },
        {
          id: "VALOR_SALDO_EXTENSO",
          label: "Saldo por extenso",
          type: "text",
          required: true,
        },
        {
          id: "FORMA_PAGAMENTO_SALDO",
          label: "Forma de pagamento do saldo",
          type: "text",
          required: true,
        },
      ],
    },
  },

  // =====================================================
  // DADOS DO CONTRATO / RODAPÉ
  // =====================================================
  {
    sectionId: "dados-contrato",
    sectionLabel: "Dados do Contrato",
    fields: [
      {
        id: "MULTA",
        label: "Percentual de multa (%)",
        type: "text",
      },
      {
        id: "COMARCA_FORO",
        label: "Comarca do foro",
        type: "text",
      },
      {
        id: "ESTADO_FORO",
        label: "Estado do foro",
        type: "text",
      },
      {
        id: "VIAS",
        label: "Quantidade de vias",
        type: "number",
      },
      {
        id: "CIDADE_ASSINATURA",
        label: "Cidade da assinatura",
        type: "text",
      },
      {
        id: "DATA_ASSINATURA",
        label: "Data da assinatura",
        type: "date",
      },
    ],
  },
];

export default compromissoCompraVendaFormSchema;